export enum AutomaticJobDispatcherNotificationType {
  /// <summary>
  /// The minutes121before job start and sign out
  /// </summary>
  //[Description("121 minutes before Job Start And Signed Out of App")]
  Minutes121beforeJobStartAndSignOut = 2,

  /// <summary>
  /// The minutes75 before job start and sign out
  /// </summary>
  //[Description("75 minutes before Job Start And Signed Out of App")]
  Minutes75BeforeJobStartAndSignOut = 4,

  /// <summary>
  /// The minutes60 before job start and sign out
  /// </summary>
  //[Description("60 minutes before Job Start And Signed Out of App")]
  Minutes60BeforeJobStartAndSignOut = 8,

  /// <summary>
  /// The minutes55 before job start and sign out
  /// </summary>
  //[Description("55 minutes before Job Start And Signed Out of App")]
  Minutes55BeforeJobStartAndSignOut = 16,

  /// <summary>
  /// The minutes50 before job start and sign out
  /// </summary>
  //[Description("50 minutes before Job Start And Signed Out of App")]
  Minutes50BeforeJobStartAndSignOut = 32,

  /// <summary>
  /// The minutes45 before job start and sign out
  /// </summary>
  //[Description("45 minutes before Job Start And Signed Out of App")]
  Minutes45BeforeJobStartAndSignOut = 64,

  /// <summary>
  /// The minutes75 before job start
  /// </summary>
  //[Description("75 minutes before Job Start")]
  Minutes75BeforeJobStart = 128,

  /// <summary>
  /// The minutes60 before job start
  /// </summary>
  //[Description("60 minutes before Job Start")]
  Minutes60BeforeJobStart = 256,

  /// <summary>
  /// The minutes55 before job start
  /// </summary>
  //[Description("55 minutes before Job Start")]
  Minutes55BeforeJobStart = 512,

  /// <summary>
  /// The minutes50 before job start
  /// </summary>
  //[Description("50 minutes before Job Start")]
  Minutes50BeforeJobStart = 1024,
  /// <summary>
  /// The minutes45 job start
  /// </summary>
  //[Description("45 minutes Job Start")] Minutes45JobStart = 2048,

  /// <summary>
  /// The minutes45 before job start
  /// </summary>
  //[Description("45 minutes before Job Start")]
  Minutes45BeforeJobStart = 4126,

  /// <summary>
  /// The minutes121 before canceled job start and sign out
  /// </summary>
  //[Description("121 minutes before Canceled Job Start And Signed Out of App")]
  Minutes121BeforeCanceledJobStartAndSignOut = 8252,

  /// <summary>
  /// The minutes121 before holiday job start and sign out
  /// </summary>
  //[Description("121 minutes before Holiday Job Start And Signed Out of App")]
  Minutes121BeforeHolidayJobStartAndSignOut = 16504,

  /// <summary>
  /// The minutes121 before canceled job start
  /// </summary>
  //[Description("121 minutes before Canceled Job Start")]
  Minutes121BeforeCanceledJobStart = 33008,

  /// <summary>
  /// The minutes121 before holiday job start
  /// </summary>
  //[Description("121 minutes before Holiday Job Start")]
  Minutes121BeforeHolidayJobStart = 66016,

  /// <summary>
  /// The minutes5 after non completed job
  /// </summary>
  //[Description("5 minutes after arriving at the last stop And non completed ride")]
  Minutes5AfterNonCompletedJob = 132032,

  /// <summary>
  /// The minutes10 after non completed job
  /// </summary>
  //[Description("10 minutes after arriving at the last stop And non completed ride")]
  Minutes10AfterNonCompletedJob = 264064,

  /// <summary>
  /// The minutes15 after non completed job
  /// </summary>
  //[Description("15 minutes after arriving at the last stop And non completed ride")]
  Minutes15AfterNonCompletedJob = 528128,

  /// <summary>
  /// The minutes20 after non completed job
  /// </summary>
  //[Description("20 minutes after arriving at the last stop And non completed ride")]
  Minutes20AfterNonCompletedJob = 1056256,

  /// <summary>
  /// The minutes25 after non completed job
  /// </summary>
  //[Description("25 minutes after arriving at the last stop And non completed ride")]
  Minutes25AfterNonCompletedJob = 2112512,

  /// <summary>
  /// The minutes30 after non completed job
  /// </summary>
  //[Description("30 minutes after arriving at the last stop And non completed ride")]
  Minutes30AfterNonCompletedJob = 4225024,

  /// <summary>
  /// The minutes25 after accepted job
  /// </summary>
  //[Description("25 minutes after accepting the job")]
  Minutes25AfterAcceptedJob = 8450048,

  /// <summary>
  /// The minutes20 after accepted job
  /// </summary>
  //[Description("20 minutes after accepting the job")]
  Minutes20AfterAcceptedJob = 16900096,

  /// <summary>
  /// The minutes151before job start
  /// </summary>
  //[Description("151 minutes before Job Start")]
  Minutes151beforeJobStart = 33800192,
}
